import React, {Fragment} from "react";
import TableBody from "@material-ui/core/TableBody";
import TableHead from "@material-ui/core/TableHead";
import {searchMembership} from "../../../api/organization-unit-functions";
import {TableLoadingRow} from "../../ui/table/TableLoadingRow";
import {withLazyDynamicTable} from "../../ui/hoc/LazyDynamicTable";
import {TableEmptyRow} from "../../ui/table/TableEmptyRow";

const _Memberships = ({
                          headerTemplate,
                          rowTemplate,
                          loading,
                          data: memberships
                      }: any) => {
    return (
        <Fragment>
            <TableHead>
                {headerTemplate()}
            </TableHead>
            <TableBody>
                {
                    loading ? <TableLoadingRow /> :
                        memberships.length === 0 ?
                            <TableEmptyRow messageKey={'Subscription.Membership.Table.EmptyMessage'}/> :
                            memberships.map(rowTemplate)
                }
            </TableBody>
        </Fragment>
    );
};


export const Memberships = (props: any) => {
    const {organizationId, organizationUnitId} = props;
    const query = ({
                       page,
                       size,
                       filter
                   }: any) => {
        return searchMembership(organizationId, organizationUnitId, {size, page, filter});
    };
    return withLazyDynamicTable(_Memberships, query, ['organizationId', 'organizationUnitId'])(props);
};
